export default {"src":"/oferta/_next/static/media/play.e01ce61a.svg","height":38,"width":41,"blurWidth":0,"blurHeight":0};